// extracted by mini-css-extract-plugin
export default {"heading":"BdIBw6","headingSmall":"DmAIQz"};